import { render, staticRenderFns } from "./CardTarjaEnqueteFechamentoSportvQRCODE.vue?vue&type=template&id=64bd5b24&scoped=true"
import script from "./CardTarjaEnqueteFechamentoSportvQRCODE.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteFechamentoSportvQRCODE.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteFechamentoSportvQRCODE.vue?vue&type=style&index=0&id=64bd5b24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bd5b24",
  null
  
)

export default component.exports